"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operationalDashboard = void 0;
exports.operationalDashboard = {
    headings: {
        title: "Operations Dashboard",
        reschedules: "Reschedules",
        returns: "Returns",
        failedJobs: "Failed Jobs",
        totalJobs: "Total Jobs",
        openJobs: "Open Jobs",
        completedJobs: "Completed Jobs",
        drivingTo: "Driving To",
        started: "Started",
        reviewedBy: "Reviewed By",
    },
    labels: {
        selectDate: "Select date",
        count: "Count",
        noData: "No data for the selected date.",
        truncated: "Results may be incomplete — the query limit was reached. Contact support if you need full data.",
        loading: "Loading…",
        total: "Total",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        unknown: "Unknown",
    },
    table: {
        columns: {
            jobRef: "Job Ref",
            address: "Address",
            postcode: "Postcode",
            date: "Date",
            actions: "Actions",
            reviewer: "Reviewer",
        },
    },
    buttons: {
        view: "View",
    },
};
